import React, { createContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import useGetAssessmentDetails from 'hooks/useGetAssessmentDetails';

export interface IAssessmentDetailsContext {
  isPractice: boolean;
}

export const AssessmentDetailsContext =
  createContext<IAssessmentDetailsContext>({
    isPractice: false,
  });

interface AssessmentDetailsProps {
  children: React.ReactNode;
}

const AssessmentDetailsProvider = ({ children }: AssessmentDetailsProps) => {
  const [isPractice, setPractice] = useState(false);
  const { interviewUid } = useParams();
  const { data: interview } = useGetAssessmentDetails(interviewUid ?? '');

  useEffect(() => {
    if (interview) {
      setPractice(interview.is_practice);
    }
  }, [interview]);

  const value = useMemo(
    () => ({
      isPractice,
    }),
    [isPractice]
  );

  return (
    <AssessmentDetailsContext.Provider value={value}>
      {children}
    </AssessmentDetailsContext.Provider>
  );
};

export default AssessmentDetailsProvider;
